export default {
	type: "number",
	displayType: "status",
	enum: [
		0,
		1,
		2
	]
};
